import { MatDialogConfig } from '@angular/material/dialog';

enum DialogSize {
  SM = '10%',
  MD = '20%',
  LG = '60%',
}

export class SynDialogConfig<T> extends MatDialogConfig {
  static readonly Size = DialogSize;
  constructor(
    public readonly id: string,
    public readonly data: T = null,
    public readonly minWidth = DialogSize.MD,
    public maxWidth = 'auto'
  ) {
    super();
    const modalConfig = new MatDialogConfig();
    modalConfig.id = this.id;
    modalConfig.maxWidth = this.maxWidth;
    modalConfig.minWidth = this.maxWidth;
    if (data != null) {
      modalConfig.data = this.data;
    }
  }
}
